import { OrdersApi, PaymentResult } from '@citruscamps/citrus-client'
import { useQuery } from 'react-query'
import { generateApiConfig } from '../../../../../utils/client-config'
import { generateItemKey } from '../../../../../utils/key-generator'
import { fromQueryParams, toSingleQueryValue } from '../../../../../utils/query-params'
import { useRequestHandler } from '../../../../../hooks/useRequestHandler'

const fromBase64 = (value: string) => {
  if (!value) return null
  return atob(value)
}

interface IConfirmPayment {
  data?: PaymentResult
  isLoading: boolean
  isError: boolean
}

export const useConfirmPayment = (): IConfirmPayment => {
  const { requestHandler } = useRequestHandler()
  const hostname = window.location.origin
  const { search } = window.location
  const query = fromQueryParams(search)
  const { token } = toSingleQueryValue(query)
  const [programId, orderId, paymentId] = fromBase64(token)?.split(':') || []
  const { data, isLoading, isError } = useQuery(
    generateItemKey({
      type: 'payment',
      program_id: programId,
      id: paymentId,
    }),
    async () => {
      if (!paymentId || !programId) {
        throw new Error('Invalid token')
      }
      const client = new OrdersApi(generateApiConfig())
      const result = await requestHandler<PaymentResult>(() =>
        client.confirmPayment({
          id: paymentId,
          order_id: orderId,
          program_id: programId,
        }),
      )
      window?.top?.postMessage('3DS-authentication-complete', hostname)
      return result
    },
    {
      enabled: typeof window !== 'undefined' && !!token,

      refetchOnWindowFocus: false,
    },
  )
  return {
    data,
    isLoading,
    isError,
  }
}
